const StatsCard = ({ title, value, icon: Icon, color }) => {
  return (
    <div className="card">
      <div className="flex items-center">
        <div className={`p-4 rounded-lg bg-${color}/10`}>
          <Icon className={`w-6 h-6 text-${color}`} />
        </div>
        <div className="ml-4">
          <h3 className="text-lg font-semibold">{title}</h3>
          <p className="text-2xl font-bold">{value}</p>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
